/**
 * The company step's job-function roles. Distinct from account-permission
 * roles (Admin/Member/workspace roles) — these feed onboarding
 * personalization and the register payload's `role`.
 */
export const ROLE_OPTIONS = [
  { value: 'founder_ceo', label: 'Founder/CEO' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'product', label: 'Product' },
  { value: 'developer', label: 'Developer' },
  { value: 'operations', label: 'Operations' },
  { value: 'other', label: 'Other' },
];
